import { render, staticRenderFns } from "./DigiBoardTimeSlotPrices.vue?vue&type=template&id=60fb0f06&scoped=true&"
import script from "./DigiBoardTimeSlotPrices.vue?vue&type=script&lang=js&"
export * from "./DigiBoardTimeSlotPrices.vue?vue&type=script&lang=js&"
import style0 from "./DigiBoardTimeSlotPrices.vue?vue&type=style&index=0&id=60fb0f06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fb0f06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCard,VCol,VContainer,VIcon,VRow})
